<template>
  <component :is="component" />
</template>

<script>
import SignupTemplate from "@/app/register/components/templates/SignupTemplate.vue";
import SignupConfirmationTemplate from "@/app/register/components/templates/SignupConfirmationTemplate.vue";
import { defineComponent } from "vue";
import httpManager from "@/app/shared/utils/httpManager";
export default defineComponent({
  components: {
    SignupTemplate,
    SignupConfirmationTemplate,
  },
  created() {
    localStorage.clear();
    httpManager.updateBaseURL(`https://backend.${import.meta.env.VITE_HOSTNAME}`);
  },
  computed: {
    component() {
      const isThereTemporalUser = this.$store.getters["isThereTemporalUser"];
      const name = isThereTemporalUser ? "signup-confirmation" : "signup";
      return `${name}-template`;
    },
  },
});
</script>
